import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-copyright',
    templateUrl: './copyright.component.html',
    styleUrls: ['./copyright.component.scss'],
    standalone: false
})
export class CopyrightComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
